module.exports = __webpack_public_path__ + "media/images/create_stallion_keeper_ship-29c64eca9f76bf41b412339c81132893.png";